
// スクロールエフェクト // Scroll Effect

/** スクロールエフェクト scroll effect  */
/** .init の要素出現時にinitを削除する remove init when .init element appears */
/** init削除で起動するエフェクトはCSSで要定義 Effects triggered by deleting init must be defined in CSS */
jQuery(function($) {
	var ww = $(window).width();
	var wh = $(window).height();
	var elms = [];

	// 起動位置（画面下から●px来たら）の設定 Set the starting position (when it comes ●px from the bottom of the screen)
	var d_0 = 0;
	var d_50 = 50;
	var d_100 = 100;
	var d_200 = 200;
	if (ww < 569) {
		d_50 = 30;
		d_100 = 50;
		d_200 = 100;
	}


	$(window).on("resize", function() {
		if ($(window).width !== ww || $(window).width > 768 ) {
			ww = $(window).width();
			wh = $(window).height();
			if (ww < 569) {
				d_50 = 30;
				d_100 = 50;
				d_200 = 100;
			} else {
				d_50 = 50;
				d_100 = 100;
				d_200 = 200;
			}
			reset();
		}

	});


	// 初期設定 Initialization
	function init() {


		if($('.init').length > 0) {
			$('.init').each(function() {
				var up = d_100;
				if ($(this).hasClass("d_200")) {
					up = d_200;
				} else if ($(this).hasClass("d_50")) {
					up = d_50;
				} else if ($(this).hasClass("d_0")) {
					up = d_0;
				}
				elms.push({done: false, position: $(this).offset().top, elm: $(this), up: up});
			});
		}

	}

	// 設定のリセット reset settings
	function reset() {

		if($('.init').length > 0) {
			for (var i=0; i < elms.length; i++) {
				if (elms[i].done == false) {
					var up = d_100;
					if (elms[i].elm.hasClass("d_200")) {
						up = d_200;
					} else if (elms[i].elm.hasClass("d_50")) {
						up = d_50;
					} else if (elms[i].elm.hasClass("d_0")) {
						up = d_0;
					}
					elms[i].position = elms[i].elm.offset().top;
					elms[i].up = up;
				}
			}
		}

	}

	// スクロールエフェクトの起動 Activate scrolling effect
	$(window).on("scroll", function() {

		scroll = $(window).scrollTop();

		if($('.init').length > 0) {
			for(var i=0; i < elms.length; i++) {
				if((scroll > (elms[i].position - wh + elms[i].up)) && elms[i].done == false ) {
					elms[i].elm.removeClass("init");
					elms[i].done = true;
					reset();
				}
			}
		}

	});

	// 初期設定 Initialization
	init();

});

// Recalculate ScrollTrigger positions after adding pin/trigger logic
// This helps when a pin (or other layout-affecting change) was added and
// other ScrollTriggers (like the .p-topRecruit__bg ones) need fresh measurements.
if (typeof window.ScrollTrigger !== 'undefined' && typeof window.ScrollTrigger.refresh === 'function') {
	// run refresh in next RAF to allow DOM changes (pin spacer) to settle
	requestAnimationFrame(function(){
		window.ScrollTrigger.refresh();
	});
}



/**
 * 1pxスクロールさせる Scroll by 1px
 */
function scrollPx() {
	var scroll = jQuery(window).scrollTop();
	window.scrollTo(0, scroll + 1);
}

// ロード時に1pxスクロールさせる scroll 1px on load
jQuery(window).on("load", function() {
	scrollPx();
})

// 個別要素ごとのアニメーションは下の each() で処理します（単体セレクタでのアニメーションは削除）
// NOTE: 初期化順が重要です。pin を追加する KV ブロックの後に初期化するため、
// この処理は KV の初期化ブロック内で実行します。


jQuery(function($){

	const top = document.querySelector('[data-top]');
	const kv = document.querySelector('[data-top-kv]');
	const about = document.querySelector('[data-top-aboutwrap]') || kv;

	if (document.querySelector('[data-kv-content]')) {
		gsap.set('[data-kv-content]', { opacity: 1 });
	}

	// gsap.to('[data-kv-content]',{
	// 	opacity:0,
	// 	scrollTrigger: {
	// 		trigger:'.p-mv',
	// 		start:'bottom 100%',
	// 		toggleActions: 'play none none reverse'
	// 	}
	// });

	// gsap.timeline({
	// 	scrollTrigger: {
	// 		trigger: kv,
	// 		pin: kv,
	// 		start: 'center center',
	// 		endTrigger: about,
	// 		end: 'bottom bottom',
	// 		pinSpacing: true,
	// 	}
	// });

	if (document.querySelector('[data-top-blur]')) {
		gsap.to('[data-top-blur]', {
			backdropFilter: 'blur(30px)',
			scrollTrigger: {
				trigger: top,
				start: 'center 20%',
				scrub: 1,
				toggleActions: 'play none none reverse',
			}
		});
	}


	const topBgEls = document.querySelectorAll('.p-topRecruit__bg');
	if (topBgEls.length) {
		topBgEls.forEach((el, i) => {
			const isOdd = ((i + 1) % 2) === 1;
			const fromX = isOdd ? '-10%' : '10%';
			const toX = isOdd ? '10%' : '-10%';
			gsap.fromTo(el, { x: fromX }, {
				x: toX,
				scrollTrigger: {
					trigger: '.p-topRecruit',
					start: 'top bottom',
					end: 'bottom top',
					scrub: 5,
				}
			});
		});
	}

	// .p-topService が画面に入ったら .l-header.front に is-scroll を付与
	const headerFront = document.querySelector('.l-header.front');
	const topService = document.querySelector('.p-topService');
	if (headerFront && topService) {
		ScrollTrigger.create({
			trigger: topService,
			start: 'top 80%',
			onEnter: () => headerFront.classList.add('is-scroll'),
			onEnterBack: () => headerFront.classList.add('is-scroll'),
			onLeaveBack: () => headerFront.classList.remove('is-scroll'),
		});
	}

	// .js-float を100vhスクロール後にフェードイン
	const floatBtn = document.querySelector('.js-float');
	if (floatBtn) {
		// 初期状態は非表示
		jQuery(floatBtn).hide();
		
		// 100vhスクロール後にフェードイン
		jQuery(window).on('scroll', function() {
			const scrollTop = jQuery(window).scrollTop();
			const viewportHeight = jQuery(window).height();
			
			if (scrollTop > viewportHeight) {
				jQuery(floatBtn).fadeIn();
			} else {
				jQuery(floatBtn).fadeOut();
			}
		});
	}
});